export function promisify(fn) {
  return () => {
    try {
      const ret = fn();
      return ret instanceof Promise ? ret : Promise.resolve(ret);
    } catch (e) {
      return Promise.reject(e);
    }
  }
}
